// eslint-disable no-undef
import { defineStore } from 'pinia';

export const pakketStore = defineStore({
  id: 'pakket',
  state: () => ({
    acceptatie_dienstwijzer: 0,
    acceptatie_verzekeringskaart: 0,
    // eslint-disable-next-line no-undef
    berekenstraat: geennee === 'true' ? 'geennee' : 'regulier',
    betalingstermijn: 'Maand',
    ingangsdatum: '',
    kosten: 0,
    maatwerk: false,
    medewerker: '',

    // needs refactor: do no place direct conditions on state variables
    module: '',
    pakket_korting: 0,
    totaalpremie: 0,
    voorlopige_dekking: 0,
    logo: '',
    naam: '',
    maatschappij: '',
    banned: false,
    taal: '',
  }),
  getters: {
    getGeennee() {
      return this.berekenstraat === 'geennee';
    },
    getGeenneFactor() {
      return this.betalingstermijn === 'Maand' && this.getGeennee ? 3 : 1;
    },
    getInsuranceApplicationType() {
      if (this.getGeennee) return 'geennee';
      if (this.maatwerk) return 'maatwerk';
      return 'aanvraag';
    },
    getJaarPremie() {
      return this.betalingstermijn === 'Maand' ? (this.totaalpremie * 12).toFixed(2) : this.totaalpremie;
    },
  },
  actions: {
    setMaatwerk(value) {
      this.maatwerk = value;
    },
    setBerekenstraat(value) {
      this.berekenstraat = value;
    },
    setModule(value) {
      if (this.module === 'personenauto' || this.module === 'bestelauto' || this.module === '') {
        this.module = value === 'auto' ? 'personenauto' : value.toLowerCase();
      }

      // The module prop is send to Laravel and must be 'kampeerauto'
      this.module = value === 'camper' ? 'kampeerauto' : value.toLowerCase();
    },
    setInitialModule(value) {
      if (this.module === '') {
        this.setModule(value);
      }
    },
    setBetalingstermijn(value) {
      this.betalingstermijn = value;
    }
  },
  persist: true,
});
